import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'data-info',
	template: require('./data-info.component.html'),
})
export class DataInfoComponent {
	constructor(private activeModalService: NgbActiveModal) {}
	title: string = '';
	public isRebrading = AppSettings.isRebrading;

	closeModal() {
		this.activeModalService.close();
	}
}
